import React from 'react';
import { BrowserView } from 'react-device-detect';

interface Props {
    titulo: string;
    descricao?: string;
}

const Cabecalho = ({ titulo, descricao }: Props): React.ReactElement =>
(
    <BrowserView>
        <div className="bg-dark mb-4 mx-n3 mx-sm-n4 mt-n3 mt-sm-n4 px-3 px-sm-4 py-2">
            <h1 className={ `text-white h5 ${descricao && 'mb-1'}` }>
                { titulo }
            </h1>
            { descricao && (
                <p className="text-muted fs-6 mb-0">
                    { descricao }
                </p>
            ) }
        </div>
    </BrowserView>
)

export default Cabecalho;
